<template>
  <div class="c-proposers">
    <div v-if="displayProposers.length">
      <div class="c-proposersTable">
        <div class="c-proposersRow c-proposersRow-header">
          <div class="c-proposersRow_col c-proposersRowHeaderName">
            提案者
          </div>
          <div class="c-proposersRow_col c-proposersRowHeaderDate">
            提案日時
          </div>
        </div>

        <template v-for="proposer in displayProposers">
          <div
            class="c-proposersRow c-proposersRow-body"
            :key="proposer.id"
          >
            <div class="c-proposersRow_col c-proposersRowIcon">
              <a
                :href="'/users/' + proposer.id"
                target="_blank"
                rel="noopener"
              >
                <c-user-icon-v2
                  :file-path="proposer.icon"
                  :user-name="proposer.name"
                  :size="28"
                />
              </a>
            </div>
            <div class="c-proposersRow_col c-proposersRowName">
              <a
                :href="'/users/' + proposer.id"
                target="_blank"
                rel="noopener"
              >
                {{ proposer.name }}
              </a>
            </div>
            <div class="c-proposersRow_col c-proposersRowDate">
              {{ $util.dayjs.unix(proposer.proposalDate).format('L') }} {{ $util.dayjs.unix(proposer.proposalDate).format('LT') }}
            </div>
          </div>
        </template>
      </div>
      <div
        class="c-readMoreProposers"
        v-if="proposersNeedReadMore && !proposersExpanded"
      >
        <a @click="proposersExpanded = true">
          もっと見る
          <coconala-icon
            name="chevron-down"
            size="11px"
          />
        </a>
      </div>
    </div>
    <div
      class="c-proposersEmpty"
      v-else
    >
      提案はまだありません
    </div>
  </div>
</template>
<script>
const PROPOSERS_NOT_EXPANSION_LIMIT_ROWS = 5

export default {
  name: 'ContentsProposers',
  props: {
    proposers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      proposersExpanded: false
    }
  },
  computed: {
    proposersNeedReadMore() {
      if (!this.proposers.length) {
        return false
      }

      if (this.proposers.length > PROPOSERS_NOT_EXPANSION_LIMIT_ROWS) {
        return true
      }

      return false
    },
    displayProposers() {
      if (!this.proposersNeedReadMore || this.proposersExpanded) {
        return this.proposers
      }

      let displayList = this.proposers.slice(0, PROPOSERS_NOT_EXPANSION_LIMIT_ROWS)
      return displayList
    }
  }
}
</script>
<style lang="scss" scoped>
.c-proposersRow {
  display: flex;
  padding: 4px 0;
  border-bottom: 1px dashed $color-gray-200;
  font-size: 12px;

  justify-content: space-between;

  &-body {
    height: 38px;
  }

  &:last-child {
    border-bottom: none;
  }
}

.c-proposersRow_col {
  display: flex;

  align-items: center;
}

.c-proposersRowHeaderDate {
  flex: 0 0 140px;
}

.c-proposersRowIcon {
  flex: 0 0 30px;
  margin-right: 12px;
}

.c-proposersRowName {
  flex: 1 1 auto;
  overflow: hidden;

  a {
    @include link-effect;

    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.c-proposersRowDate {
  flex: 0 0 140px;
  font-size: 11px;
}

.c-readMoreProposers {
  margin: 8px 0;
  color: $color-blue-500;
  font-size: 13px;
}

.c-proposersEmpty {
  display: flex;
  padding: 12px;
  width: 100%;
  height: 80px;
  background-color: $color-gray-50;
  font-size: 14px;

  align-items: center;
  justify-content: center;
}

@media (max-width: breakpoint(Requests, M)) {
  .c-proposers {
    border-bottom: 1px solid $color-gray-200;
  }

  .c-proposersTable {
    padding: 12px;
  }

  .c-proposersRowHeaderDate {
    flex: 0 0 104px;
  }

  .c-proposersRowDate {
    flex: 0 0 104px;
  }

  .c-readMoreProposers {
    margin: 0;
    padding: 0 0 12px;
    text-align: center;
    font-size: 12px;
  }

  .c-proposersEmpty {
    background-color: $color-white;
  }
}
</style>
